import React from 'react';
import { Fragment } from 'preact';
import { Loader } from '@googlemaps/js-api-loader';

const Marker = `<?xml version="1.0" encoding="UTF-8"?>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 1009.5 1329.3">
  <defs>
    <style>
      .cls-1 {
        fill: #392464;
      }

      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43 {
        stroke-width: 0px;
      }

      .cls-44 {
        clip-path: url(#clippath);
      }

      .cls-2 {
        fill: none;
      }

      .cls-3 {
        fill: #48277c;
      }

      .cls-4 {
        fill: url(#linear-gradient);
      }

      .cls-5 {
        fill: url(#linear-gradient-38);
      }

      .cls-6 {
        fill: url(#linear-gradient-33);
      }

      .cls-7 {
        fill: url(#linear-gradient-29);
      }

      .cls-8 {
        fill: url(#linear-gradient-32);
      }

      .cls-9 {
        fill: url(#linear-gradient-30);
      }

      .cls-10 {
        fill: url(#linear-gradient-31);
      }

      .cls-11 {
        fill: url(#linear-gradient-36);
      }

      .cls-12 {
        fill: url(#linear-gradient-34);
      }

      .cls-13 {
        fill: url(#linear-gradient-37);
      }

      .cls-14 {
        fill: url(#linear-gradient-35);
      }

      .cls-15 {
        fill: url(#linear-gradient-28);
      }

      .cls-16 {
        fill: url(#linear-gradient-25);
      }

      .cls-17 {
        fill: url(#linear-gradient-11);
      }

      .cls-18 {
        fill: url(#linear-gradient-12);
      }

      .cls-19 {
        fill: url(#linear-gradient-13);
      }

      .cls-20 {
        fill: url(#linear-gradient-10);
      }

      .cls-21 {
        fill: url(#linear-gradient-17);
      }

      .cls-22 {
        fill: url(#linear-gradient-16);
      }

      .cls-23 {
        fill: url(#linear-gradient-19);
      }

      .cls-24 {
        fill: url(#linear-gradient-15);
      }

      .cls-25 {
        fill: url(#linear-gradient-23);
      }

      .cls-26 {
        fill: url(#linear-gradient-21);
      }

      .cls-27 {
        fill: url(#linear-gradient-18);
      }

      .cls-28 {
        fill: url(#linear-gradient-14);
      }

      .cls-29 {
        fill: url(#linear-gradient-22);
      }

      .cls-30 {
        fill: url(#linear-gradient-20);
      }

      .cls-31 {
        fill: url(#linear-gradient-27);
      }

      .cls-32 {
        fill: url(#linear-gradient-24);
      }

      .cls-33 {
        fill: url(#linear-gradient-26);
      }

      .cls-45 {
        clip-path: url(#clippath-1);
      }

      .cls-46 {
        clip-path: url(#clippath-4);
      }

      .cls-47 {
        clip-path: url(#clippath-3);
      }

      .cls-48 {
        clip-path: url(#clippath-2);
      }

      .cls-49 {
        clip-path: url(#clippath-7);
      }

      .cls-50 {
        clip-path: url(#clippath-8);
      }

      .cls-51 {
        clip-path: url(#clippath-6);
      }

      .cls-52 {
        clip-path: url(#clippath-5);
      }

      .cls-53 {
        clip-path: url(#clippath-9);
      }

      .cls-34 {
        fill: #f3d7f1;
      }

      .cls-54 {
        clip-path: url(#clippath-60);
      }

      .cls-55 {
        clip-path: url(#clippath-69);
      }

      .cls-56 {
        clip-path: url(#clippath-20);
      }

      .cls-57 {
        clip-path: url(#clippath-21);
      }

      .cls-58 {
        clip-path: url(#clippath-24);
      }

      .cls-59 {
        clip-path: url(#clippath-23);
      }

      .cls-60 {
        clip-path: url(#clippath-22);
      }

      .cls-61 {
        clip-path: url(#clippath-25);
      }

      .cls-62 {
        clip-path: url(#clippath-44);
      }

      .cls-63 {
        clip-path: url(#clippath-45);
      }

      .cls-64 {
        clip-path: url(#clippath-40);
      }

      .cls-65 {
        clip-path: url(#clippath-42);
      }

      .cls-66 {
        clip-path: url(#clippath-41);
      }

      .cls-67 {
        clip-path: url(#clippath-47);
      }

      .cls-68 {
        clip-path: url(#clippath-43);
      }

      .cls-69 {
        clip-path: url(#clippath-46);
      }

      .cls-70 {
        clip-path: url(#clippath-48);
      }

      .cls-71 {
        clip-path: url(#clippath-49);
      }

      .cls-72 {
        clip-path: url(#clippath-84);
      }

      .cls-73 {
        clip-path: url(#clippath-88);
      }

      .cls-74 {
        clip-path: url(#clippath-86);
      }

      .cls-75 {
        clip-path: url(#clippath-81);
      }

      .cls-76 {
        clip-path: url(#clippath-83);
      }

      .cls-77 {
        clip-path: url(#clippath-85);
      }

      .cls-78 {
        clip-path: url(#clippath-80);
      }

      .cls-79 {
        clip-path: url(#clippath-87);
      }

      .cls-80 {
        clip-path: url(#clippath-82);
      }

      .cls-81 {
        clip-path: url(#clippath-98);
      }

      .cls-82 {
        clip-path: url(#clippath-89);
      }

      .cls-83 {
        clip-path: url(#clippath-27);
      }

      .cls-84 {
        clip-path: url(#clippath-28);
      }

      .cls-85 {
        clip-path: url(#clippath-26);
      }

      .cls-86 {
        clip-path: url(#clippath-29);
      }

      .cls-87 {
        clip-path: url(#clippath-34);
      }

      .cls-88 {
        clip-path: url(#clippath-35);
      }

      .cls-89 {
        clip-path: url(#clippath-36);
      }

      .cls-90 {
        clip-path: url(#clippath-37);
      }

      .cls-91 {
        clip-path: url(#clippath-39);
      }

      .cls-92 {
        clip-path: url(#clippath-33);
      }

      .cls-93 {
        clip-path: url(#clippath-32);
      }

      .cls-94 {
        clip-path: url(#clippath-30);
      }

      .cls-95 {
        clip-path: url(#clippath-38);
      }

      .cls-96 {
        clip-path: url(#clippath-31);
      }

      .cls-97 {
        clip-path: url(#clippath-95);
      }

      .cls-98 {
        clip-path: url(#clippath-99);
      }

      .cls-99 {
        clip-path: url(#clippath-93);
      }

      .cls-100 {
        clip-path: url(#clippath-94);
      }

      .cls-101 {
        clip-path: url(#clippath-91);
      }

      .cls-102 {
        clip-path: url(#clippath-96);
      }

      .cls-103 {
        clip-path: url(#clippath-90);
      }

      .cls-104 {
        clip-path: url(#clippath-92);
      }

      .cls-105 {
        clip-path: url(#clippath-97);
      }

      .cls-106 {
        clip-path: url(#clippath-53);
      }

      .cls-107 {
        clip-path: url(#clippath-54);
      }

      .cls-108 {
        clip-path: url(#clippath-50);
      }

      .cls-109 {
        clip-path: url(#clippath-51);
      }

      .cls-110 {
        clip-path: url(#clippath-52);
      }

      .cls-111 {
        clip-path: url(#clippath-55);
      }

      .cls-112 {
        clip-path: url(#clippath-56);
      }

      .cls-113 {
        clip-path: url(#clippath-57);
      }

      .cls-114 {
        clip-path: url(#clippath-58);
      }

      .cls-115 {
        clip-path: url(#clippath-79);
      }

      .cls-116 {
        clip-path: url(#clippath-61);
      }

      .cls-117 {
        clip-path: url(#clippath-64);
      }

      .cls-118 {
        clip-path: url(#clippath-62);
      }

      .cls-119 {
        clip-path: url(#clippath-68);
      }

      .cls-120 {
        clip-path: url(#clippath-67);
      }

      .cls-121 {
        clip-path: url(#clippath-73);
      }

      .cls-122 {
        clip-path: url(#clippath-59);
      }

      .cls-123 {
        clip-path: url(#clippath-65);
      }

      .cls-124 {
        clip-path: url(#clippath-63);
      }

      .cls-125 {
        clip-path: url(#clippath-66);
      }

      .cls-126 {
        clip-path: url(#clippath-70);
      }

      .cls-127 {
        clip-path: url(#clippath-75);
      }

      .cls-128 {
        clip-path: url(#clippath-72);
      }

      .cls-129 {
        clip-path: url(#clippath-78);
      }

      .cls-130 {
        clip-path: url(#clippath-71);
      }

      .cls-131 {
        clip-path: url(#clippath-77);
      }

      .cls-132 {
        clip-path: url(#clippath-74);
      }

      .cls-133 {
        clip-path: url(#clippath-76);
      }

      .cls-134 {
        clip-path: url(#clippath-14);
      }

      .cls-135 {
        clip-path: url(#clippath-13);
      }

      .cls-136 {
        clip-path: url(#clippath-12);
      }

      .cls-137 {
        clip-path: url(#clippath-10);
      }

      .cls-138 {
        clip-path: url(#clippath-15);
      }

      .cls-139 {
        clip-path: url(#clippath-17);
      }

      .cls-140 {
        clip-path: url(#clippath-16);
      }

      .cls-141 {
        clip-path: url(#clippath-19);
      }

      .cls-142 {
        clip-path: url(#clippath-11);
      }

      .cls-143 {
        clip-path: url(#clippath-18);
      }

      .cls-35 {
        fill: #f8b40c;
      }

      .cls-36 {
        fill: url(#linear-gradient-4);
      }

      .cls-37 {
        fill: url(#linear-gradient-2);
      }

      .cls-38 {
        fill: url(#linear-gradient-3);
      }

      .cls-39 {
        fill: url(#linear-gradient-8);
      }

      .cls-40 {
        fill: url(#linear-gradient-9);
      }

      .cls-41 {
        fill: url(#linear-gradient-7);
      }

      .cls-42 {
        fill: url(#linear-gradient-5);
      }

      .cls-43 {
        fill: url(#linear-gradient-6);
      }

      .cls-144 {
        clip-path: url(#clippath-113);
      }

      .cls-145 {
        clip-path: url(#clippath-112);
      }

      .cls-146 {
        clip-path: url(#clippath-111);
      }

      .cls-147 {
        clip-path: url(#clippath-110);
      }

      .cls-148 {
        clip-path: url(#clippath-115);
      }

      .cls-149 {
        clip-path: url(#clippath-114);
      }

      .cls-150 {
        clip-path: url(#clippath-105);
      }

      .cls-151 {
        clip-path: url(#clippath-100);
      }

      .cls-152 {
        clip-path: url(#clippath-102);
      }

      .cls-153 {
        clip-path: url(#clippath-103);
      }

      .cls-154 {
        clip-path: url(#clippath-107);
      }

      .cls-155 {
        clip-path: url(#clippath-109);
      }

      .cls-156 {
        clip-path: url(#clippath-104);
      }

      .cls-157 {
        clip-path: url(#clippath-101);
      }

      .cls-158 {
        clip-path: url(#clippath-108);
      }

      .cls-159 {
        clip-path: url(#clippath-106);
      }
    </style>
    <clipPath id="clippath">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-1">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-2">
      <path class="cls-2" d="M433.8,1746.2c-337,0-527.1,160.5-565,477.2-2.4,20.4,5.4,36.9,10.5,47.8.9,1.9,2.3,4.8,3,6.7-3.5,17.5-36.2,68.5-54.3,96.7-37.6,58.8-70.1,109.6-70.1,149.3s44.4,73.1,77,90.9c8.4,4.6,22.8,12.4,29.9,18.1-.9,1.9-1.7,3.7-2.2,4.8-5.3,11.2-12,25.2-12.5,41.4-.4,13.5,4.7,24.1,10.6,32.3-4.2,7.9-7.7,18.4-7.7,31.8s9,32.5,17,41.7c-.5,4.3-1.1,8.6-1.6,13.1l-.3,2.5c-6.4,51.4-13.7,109.7,26.5,136.8,42.7,29,95.8,35,147.4,40.9,96.1,10.9,122.8,21.2,128.1,73.9l15.5,129.6c2.6,21.1,20.5,37,41.7,37h455.3c23.2,0,42-18.8,42-42v-38.7c-.2-61.3-.5-223.5,6.7-246.2,21-34.7,52.2-68.6,85.2-104.6,90.3-98.4,202.7-220.8,202.7-455.6s-262.6-585.4-585.5-585.4M658.5,2849.8c-15.8,26.3-18.3,91.1-17.9,284.9h-376l-11-91.8c-12.7-126.7-122.2-139.1-202.2-148.2-38.5-4.3-78.1-8.8-104.2-23.5-.9-9.5.5-29.8,4.3-60.4,1.7-13.4,3.2-25.3,4-36.3,1.2-15.6-5.6-26.8-11.9-34.3,4.4-6.9,8.6-16.4,9.5-28.9,1.1-16.9-6.7-29.6-14-38.3,6-12.6,13.8-29.6,11.9-49.1-4.4-43.9-45.7-66.5-76-83-9.5-5.2-26.3-14.3-32.3-20.1,4.4-19.6,39.1-73.7,56.6-101,36.3-56.8,65-101.6,67.5-138.2,1.3-19.7-6.2-35.6-11.5-46.8-.7-1.5-1.7-3.6-2.3-5.2,33.5-268.7,190.9-399.4,481.1-399.4s501.4,225,501.4,501.4-96,306.5-180.6,398.7h0c-36.3,39.6-70.6,76.9-96.1,119.4"/>
    </clipPath>
    <clipPath id="clippath-3">
      <rect class="cls-2" x="-242" y="1746.2" width="1261.3" height="1472.5"/>
    </clipPath>
    <linearGradient id="linear-gradient" x1="428.1" y1="1017.4" x2="468.9" y2="1017.4" gradientTransform="translate(-13481.3 33949.9) scale(30.9 -30.9)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#429fd6"/>
      <stop offset=".2" stop-color="#429fd6"/>
      <stop offset="1" stop-color="#48277c"/>
      <stop offset="1" stop-color="#1d1d1b"/>
    </linearGradient>
    <clipPath id="clippath-4">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-5">
      <path class="cls-2" d="M788.5,7597.2c-69.9-47.1-163.3-59.5-243.5-32.2-51.1,17.3-93.4,49.3-124.3,93.3-30.9-44-73.2-75.9-124.3-93.4-80.3-27.2-173.6-14.8-243.5,32.2-123.7,83.4-196.3,279.4-87.2,478.6,73,133.2,190.7,199.1,294.7,257.3l11.8-21.1-11.2,21.5c49.8,28,96.9,54.4,134.8,85.7,7,5.8,15.8,9,24.9,9s17.9-3.2,24.9-9c38-31.4,85.2-57.8,135.5-86,103.9-58.2,221.7-124.2,294.7-257.3,109.1-199.3,36.5-395.3-87.2-478.6M96.5,7662.1c31.5-21.2,71.5-33,112.4-33s42.8,3.3,62.2,10c37.5,12.7,87.4,43.6,112.4,118.2,5.3,15.9,20.3,26.7,37.1,26.7s31.8-10.7,37.1-26.7c25.1-74.7,75-105.5,112.4-118.2,56.7-19.3,125.2-10.3,174.6,23,95,64,149.1,217.5,62.3,376-62.1,113.4-164.9,171-265.3,227.2-43.1,24.1-84,47.1-121.1,74.1-37.4-27.2-78.8-50.4-122.2-74.7-99.3-55.7-202.1-113.2-264.2-226.6-86.9-158.5-32.7-312,62.3-376"/>
    </clipPath>
    <clipPath id="clippath-6">
      <rect class="cls-2" x="-143.6" y="7537.7" width="1128.4" height="890.4"/>
    </clipPath>
    <linearGradient id="linear-gradient-2" x1="428.7" y1="791.5" x2="469.5" y2="791.5" gradientTransform="translate(-10779.2 27718.8) scale(24.9 -24.9)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#f7af2c"/>
      <stop offset=".3" stop-color="#f7af2c"/>
      <stop offset=".9" stop-color="#e32978"/>
      <stop offset="1" stop-color="#e32978"/>
    </linearGradient>
    <clipPath id="clippath-7">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-8">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-9">
      <path class="cls-2" d="M5419.5,5299.2c24.4,6.9,49.7,8,72.1,9.1l4.6.2c28.7,1.3,56.8,1.3,82.8,1.1,4.4,0,8.9,0,13.5.2,17.4.3,37.2.7,56.7-4.2,56.3-14.2,93.3-68.6,87.9-129.4-5.5-62.8-53.9-108.2-118.8-110.2-12.4,0-25-.4-37.7-.8-27.2-.8-55.1-1.7-83,.9-11.2.9-27.6-11.1-38.3-27.5-6.9-10.6-12.5-22.6-18.5-35.2-15.7-33-33.5-70.4-78.1-92.5-56.3-27.8-118.4-27.9-170.4-.2-65.8,34.9-79.3,97.3-91.2,152.4-1.2,5.7-2.5,11.5-3.8,17.2l-57.7,253.5c-12.6,54.4-27,116.2,10.1,177.8,30.5,50.6,80.3,76.1,148.2,76.1h4.1c14.1-.2,28.1-.1,42.3,0h169.8v203.8c0,39.5,0,88.7,43,125.2,24.3,20.6,55.2,30.8,86,30.8s71.8-13.8,96.8-40.8c32.7-35.3,32.5-77.9,32.4-112.2v-305.2c0-36.7,0-98-56.6-137-40.6-27.9-94-25.5-136.9-23.7-9.7.4-19.2.9-27.9.9h-68.9l9.4-41.4c9.1,4.5,18.4,8.3,28.1,11.1M5563.7,5471.9v113.8c0,26.1.2,52.2.4,78.3.5,50.9,1,103.4-.4,154.7-.3,9.7-5.1,14.8-9.1,17.3-6.6,4.1-15.1,4.3-23.4.5-6.9-3.1-8.8-8.5-8.7-38.4v-264.6c0-29.9-24.3-54.3-54.2-54.3h-243.3c-5.5,0-11,.1-16.6.3-17.3.4-33.5.9-44.5-4.1-35.6-16.4-31-62.4-25-88.5l74.2-325.8c5.6-25,9.1-38.6,20.8-48.3,23.8-19.7,65.7-19.5,89.7.7,7.4,6.2,13.9,21.5,19.7,35,2.7,6.2,5.2,12.2,8,17.8,9.2,19.1,24.3,46.9,49,68.6,29,25.4,60.3,39,90.6,39.6,28.6.4,57.5.3,85.5.2,14.1,0,28.1-.2,41-.2,4.2.2,7.3,1.4,9.2,3.8,2.4,3,3.3,7.7,2.5,13.1-.9,5.7-1.5,9.2-29.5,9.5-37.5.4-76.2.8-113.5-1.6l-6.4-.4c-11.5-.7-23.5-1.4-31.2-4.2-14.2-5.2-30.1-16.2-45.5-26.8-6.3-4.3-12.5-8.6-18.5-12.5-14.5-9.3-32.9-10.8-49.3-4.1-16.4,6.7-28.4,20.7-32.2,37.3l-41.6,182.5c-3.8,16.6.1,33.7,10.7,46.9,10.2,12.8,25.6,20.2,42,20.2,24.8,0,49.6-.1,74.4-.2,48.5-.2,98.6-.5,147.7.2,9,.1,27.7.4,27.7,33.8"/>
    </clipPath>
    <clipPath id="clippath-10">
      <rect class="cls-2" x="5012.5" y="4883.2" width="729.9" height="1064.3"/>
    </clipPath>
    <linearGradient id="linear-gradient-3" x1="705.4" y1="818.7" x2="746.1" y2="818.7" gradientTransform="translate(-7282.4 19701.7) scale(17.4 -17.4)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-11">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-12">
      <path class="cls-2" d="M5408.6,4892c12.4,0,25-1.1,37.5-3.4,93.8-17.4,163.4-101.2,165.6-199.4,0-.6,0-1.1,0-1.7-2-86.6-54.7-161.5-134.4-190.8-79.6-29.3-172.8-3.8-226.8,62-54.1,65.9-61.7,159.4-18.8,232.6,36.9,63.1,105,100.7,176.9,100.7M5407.8,4593c52,0,93.7,41.8,95.4,95.4-1.6,53.5-43.4,95.4-95.4,95.4s-95.3-43.7-95.3-95.4,43.6-95.4,95.3-95.4"/>
    </clipPath>
    <clipPath id="clippath-13">
      <rect class="cls-2" x="5188.9" y="4467.3" width="422.8" height="424.7"/>
    </clipPath>
    <linearGradient id="linear-gradient-4" x1="913" y1="708.7" x2="953.8" y2="708.7" gradientTransform="translate(-3920.7 11762.7) scale(10 -10)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-14">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-15">
      <path class="cls-2" d="M5311.5,5716.7h4c30.1,0,53.6-24,53.5-54.5,0-30.3-23.6-54.1-53.6-54.1h-.1c-37.2.2-75-.4-112.6-1.4-5.4-1.8-11.1-2.9-17.2-2.9s-9.5.8-14.1,2c-25.2-.8-50.4-1.6-75.2-2.4l-28.1-.9c-52.6-92.8-79.3-198.8-73.5-293.5,1.8-29.9-19.5-53.9-49.6-55.7-30.9-1.8-56.9,20.6-58.8,51.3-8.9,145.3,45.6,276.2,93,360.6.7,1.2,1.3,2.5,2,3.9,3.9,7.7,9.2,18.4,18.8,26.8,16.5,14.4,36,14.5,46.5,14.6h3.9c27,.9,53.9,1.6,80.8,2.4v178.7h-50.4c-30.1,0-53.7,23.9-53.7,54.3s23.6,54.3,53.7,54.3h209.3c30.1,0,53.7-23.9,53.7-54.3s-4.6-26.2-13.1-36c-10.1-11.8-24.5-18.3-40.6-18.3h-50.3v-175.7c23.8.6,47.8,1,71.7,1"/>
    </clipPath>
    <clipPath id="clippath-16">
      <rect class="cls-2" x="4877.2" y="5251.4" width="491.9" height="748.5"/>
    </clipPath>
    <linearGradient id="linear-gradient-5" x1="813.9" y1="686.6" x2="854.6" y2="686.6" gradientTransform="translate(-4770.3 13771.8) scale(11.9 -11.9)" xlink:href="#linear-gradient-2"/>
    <clipPath id="clippath-17">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-18">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-19">
      <path class="cls-2" d="M6180.7,4774.8c-13.4,0-26.2,4.6-36,13.1-11.7,10.1-18.3,24.5-18.3,40.6v295.7h-254.1c-30.1,0-53.7,23.9-53.7,54.3s23.6,54.3,53.7,54.3h308.4c29.9,0,54.3-24.3,54.3-54.3v-350c0-30.1-23.9-53.7-54.3-53.7"/>
    </clipPath>
    <clipPath id="clippath-20">
      <rect class="cls-2" x="5818.6" y="4774.8" width="416.4" height="458"/>
    </clipPath>
    <linearGradient id="linear-gradient-6" x1="961.9" y1="685.2" x2="1002.7" y2="685.2" gradientTransform="translate(-4002.7 11999.5) scale(10.2 -10.2)" xlink:href="#linear-gradient-2"/>
    <clipPath id="clippath-21">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-22">
      <path class="cls-2" d="M3048.8,2183.8h-243.4c-26.1,0-46.7,20.8-46.7,47.2s20.5,47.3,46.7,47.3h243.4c26.2,0,46.7-20.8,46.7-47.3s-20.5-47.2-46.7-47.2"/>
    </clipPath>
    <clipPath id="clippath-23">
      <rect class="cls-2" x="2758.8" y="2183.8" width="336.7" height="94.5"/>
    </clipPath>
    <linearGradient id="linear-gradient-7" x1="721.5" y1="923.5" x2="762.3" y2="923.5" gradientTransform="translate(-3197.5 9854.9) scale(8.3 -8.3)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-24">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-25">
      <path class="cls-2" d="M2621.3,2145.9l-62.6,71.9-16.8-14.7c-13-11.4-30.4-14.8-46.5-9.3-16.4,5.6-29.1,19.9-32.3,36.4-3.1,15.7,2.6,31.6,15.1,42.5l53.3,46.5c9.5,8.2,21.1,12.3,32.5,12.3s25.4-5.1,34.2-15.3l93-106.6c17.6-20.2,15.3-50.1-5.2-68-19.7-17.2-47.4-15.4-64.5,4.2"/>
    </clipPath>
    <clipPath id="clippath-26">
      <rect class="cls-2" x="2459.9" y="2124.5" width="248.8" height="207"/>
    </clipPath>
    <linearGradient id="linear-gradient-8" x1="780.5" y1="868.6" x2="821.3" y2="868.6" gradientTransform="translate(-2145.2 7355.1) scale(5.9 -5.9)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#f7af2c"/>
      <stop offset=".9" stop-color="#e32978"/>
      <stop offset="1" stop-color="#e32978"/>
    </linearGradient>
    <clipPath id="clippath-27">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-28">
      <path class="cls-2" d="M3048.8,2450.9h-243.4c-26.1,0-46.7,20.8-46.7,47.3s20.5,47.3,46.7,47.3h243.4c26.2,0,46.7-20.8,46.7-47.3s-20.5-47.3-46.7-47.3"/>
    </clipPath>
    <clipPath id="clippath-29">
      <rect class="cls-2" x="2758.8" y="2450.9" width="336.7" height="94.5"/>
    </clipPath>
    <linearGradient id="linear-gradient-9" x1="721.5" y1="891.9" x2="762.3" y2="891.9" gradientTransform="translate(-3197.5 9861.4) scale(8.3 -8.3)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-30">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-31">
      <path class="cls-2" d="M2621.3,2413l-62.6,71.8-16.8-14.6c-13-11.4-30.4-14.8-46.5-9.3-16.4,5.6-29.1,19.9-32.3,36.4-3.1,15.7,2.6,31.6,15.1,42.5l53.3,46.5c9.5,8.2,21.1,12.3,32.5,12.3s25.4-5.1,34.2-15.3l93-106.6c17.6-20.2,15.3-50.1-5.2-68-19.7-17.2-47.4-15.3-64.5,4.2"/>
    </clipPath>
    <clipPath id="clippath-32">
      <rect class="cls-2" x="2459.9" y="2391.6" width="248.7" height="207"/>
    </clipPath>
    <linearGradient id="linear-gradient-10" x1="780.5" y1="824.4" x2="821.3" y2="824.4" gradientTransform="translate(-2145.2 7361.6) scale(5.9 -5.9)" xlink:href="#linear-gradient-8"/>
    <clipPath id="clippath-33">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-34">
      <path class="cls-2" d="M3048.8,2718h-243.4c-26.1,0-46.7,20.8-46.7,47.3s20.5,47.2,46.7,47.2h243.4c26.2,0,46.7-20.7,46.7-47.2s-20.5-47.3-46.7-47.3"/>
    </clipPath>
    <clipPath id="clippath-35">
      <rect class="cls-2" x="2758.8" y="2718" width="336.7" height="94.5"/>
    </clipPath>
    <linearGradient id="linear-gradient-11" x1="721.5" y1="860.3" x2="762.3" y2="860.3" gradientTransform="translate(-3197.5 9868) scale(8.3 -8.3)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-36">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-37">
      <path class="cls-2" d="M2621.3,2680l-62.6,71.8-16.8-14.6c-13-11.4-30.4-14.8-46.5-9.3-16.4,5.6-29.1,19.9-32.3,36.4-3.1,15.7,2.6,31.6,15.1,42.5l53.3,46.5c9.5,8.3,21.1,12.4,32.5,12.4s25.4-5.1,34.2-15.3l93-106.6c17.6-20.3,15.3-50.1-5.2-68-19.7-17.2-47.4-15.3-64.5,4.2"/>
    </clipPath>
    <clipPath id="clippath-38">
      <rect class="cls-2" x="2459.9" y="2658.7" width="248.7" height="207"/>
    </clipPath>
    <linearGradient id="linear-gradient-12" x1="780.5" y1="780.3" x2="821.3" y2="780.3" gradientTransform="translate(-2145.2 7368.1) scale(5.9 -5.9)" xlink:href="#linear-gradient-8"/>
    <clipPath id="clippath-39">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-40">
      <path class="cls-2" d="M3315.6,2951.7v-864.6c0-11.5,0-23,.1-34.5,0-23.3.2-46.7-.1-70-.7-41.7-20.6-75.2-54.6-91.9-26.9-13.2-59.3-11.8-85.3-10.6-6.7.3-13.1.6-19.1.6h-85c-5.3,0-10.2,1.1-14.9,2.6-3-12.9-8.7-24.7-17-34.7-15.7-18.9-39.2-29.6-66.3-30.3-43.4-1.1-87.4-.7-129.9-.4-21.4.2-42.8.3-64.2.3h-103.5c-3.3,0-6.6,0-10-.2-20.7-.5-46.5-1.2-69.3,14.1-18.1,12.1-30,29.9-34.7,50.9-4.5-1.3-9.1-2.3-14.1-2.3h-87.2c-5.7,0-11.8-.3-18.1-.5-28.2-1.1-63.2-2.6-91.6,14.7-48.2,29.3-47.6,79-47.1,115.2,0,3.7.1,7.3.1,11v986.3c-.1,10.6-.2,22.6,3.1,35.4,11.7,44.5,50.6,72.4,101.6,72.9,86.7.7,174.8.4,260,.2,43.2-.1,86.5-.2,129.7-.2h341.4c6.5,0,13.5.2,20.8.4,7.2.2,15.3.5,23.9.5,49.8,0,117.5-8.7,129.8-82.5,3.4-20.5,2.7-40.8,2-60.5-.3-7.3-.5-14.6-.5-21.7M2660,1912.8h260.5c6.3,0,12.8-.2,19.4-.4,8.3-.3,16.3-.6,23.9-.4-.6,1.9-1.3,4-2.4,6.3-7.1,15.7-21.9,25.1-39.6,25.8h-144.3c-7.7,0-15.8.2-24.2.5-61.5,2-88.6-2-97.3-31.9,1.3,0,2.7,0,4,0M3221.8,2019c-.4,6.9-.8,13.2-.8,18.4v959c0,2.7,0,5.3.2,8,.1,4.1.2,8,0,10.9-.2,2.2-.6,3.4-.5,3.7-1.3.7-5.6,2-18.5,2h-785.9c-13.9,0-17.3-2.1-17.2-1.7,0,0-.6-1.2-.9-4-1.2-14.7-.8-30.3-.4-46.7.2-8.6.5-17.2.5-25.7v-954.2c0-4.2,0-10.7.6-12.2,7-4.9,35.9-3,48.2-2.2,7.7.5,14.6.9,20.4.9h80.3c11,0,20.8-3.8,28.8-10,8.4,15.5,18.9,29,29.4,38.3,34.9,30.9,75.7,35.1,111.1,35.1h205.8c52.7-1.9,97.4-30.2,120.4-72.8,8,6.2,17.8,9.5,28.5,9.5h82.6c5.5,0,12.1-.4,19.4-.9,12.1-.8,40.5-2.6,46.5,1.5,4,6.7,2.4,32.2,1.7,43.1"/>
    </clipPath>
    <clipPath id="clippath-41">
      <rect class="cls-2" x="2302.6" y="1816.9" width="1014.9" height="1299.7"/>
    </clipPath>
    <linearGradient id="linear-gradient-13" x1="522.6" y1="1007" x2="563.4" y2="1007" gradientTransform="translate(-10677.5 27481.7) scale(24.8 -24.8)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-42">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-43">
      <path class="cls-2" d="M3754.1,2270.9c-9.5-23-5.5-54.4-1.7-84.7,1.8-14.3,3.7-29,4.2-43.4,1.4-37.6-20.9-72.3-55.7-86.3-20.8-8.4-42.3-7.7-61.2-7.1h0c-.2-28.1-3.7-57.3-18.4-80.6-28.3-44.5-87.6-50.5-133.6-41.4-45.3,9-74.9,49.9-75.5,104.2-1.1,88.3-.7,177.9-.4,264.6.2,44,.4,87.9.4,131.9v215.9c0,59.9,0,127.7,13.1,195.8,7.5,38.9,18.9,77.8,33.8,115.5,5,12.4,13,22.6,22.6,30.3-2.6,5.9-4,12.3-4,19.1v51.3c0,26.1,20.8,46.7,47.3,46.7s22.8-4,31.4-11.4c10.2-8.8,15.9-21.3,15.9-35.3v-51.3c0-6.7-1.4-12.9-3.8-18.6,19.7-16,27.6-41,33.2-59.1.8-2.6,1.6-5.1,2.4-7.6,22.1-67,33.5-140,33.8-216.9.1-26.5,0-53,0-79.5v-479.4c1.5,0,3,0,4.6-.2,6.3-.4,13.7-.8,19.2-.3-.2,2.6-.6,5.6-.9,7.9-.3,2.1-.5,4.2-.7,6.2-.5,4.7-1.1,9.5-1.6,14.5-4.5,40-10.1,89.7,6.8,130.9,6.6,16.2,21,27.3,38.4,29.6,2.3.3,4.6.4,6.9.4,15,0,29.2-6.6,38.1-18.1,9.6-12.4,11.6-28.8,5.4-44M3509.6,2020.1h.5c6.8-.7,23.9-2.3,31.3-.8.8,1.7,1.8,5.3,2,10.4.2,6.6.2,13.3.1,19.9h-38.1c0-12.1.9-24.6,4.1-29.6M3525.6,2851.2c-20.6-88.4-19.9-180-19.1-275.8.1-17.8.2-35.6.2-53.4v-377.7h36.7v336.4c0,26.5.5,53.4,1,80.5,1.9,97.7,3.8,198.7-18.9,290"/>
    </clipPath>
    <clipPath id="clippath-44">
      <rect class="cls-2" x="3411.2" y="1918.3" width="349.2" height="1184.6"/>
    </clipPath>
    <linearGradient id="linear-gradient-14" x1="466.6" y1="922.5" x2="507.4" y2="922.5" gradientTransform="translate(-7742.2 23908.9) scale(23.2 -23.2)" xlink:href="#linear-gradient-8"/>
    <clipPath id="clippath-45">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-46">
      <path class="cls-2" d="M5230.5,8644.5c-8-1.4-15.9-2.7-23.3-4.3h0c-50.1-10.6-99.8-9.4-161.2,3.9-6.2,1.3-12.7,2.5-19.1,3.6-35.6,6.4-84.5,15.2-114.6,59.9-26.2,38.8-25.2,83.2-24.4,118.9.2,6,.3,11.9.3,17.8,0,33.7,26.7,60.2,60.8,60.2s29.2-5.2,40.3-14.7c13.2-11.4,20.5-27.5,20.5-45.5s-.3-13.6-.7-21c-.7-15.2-1.7-38.2,2.8-45.9,5.4-5.8,31.8-10,44.5-12.1,7.8-1.3,15.2-2.5,21.9-3.9,39.3-8.5,71.2-9.3,103.3-2.5,7.2,1.5,15.8,2.9,25,4.3,14.6,2.2,45,7,52.4,12.8,16.3,14.8,38.5,19.8,59.2,13.2,21.4-6.8,37.6-24.4,42.3-46,4.5-20.5-2.4-41.4-18.3-55.8-32.2-29.4-76.2-37-111.5-43"/>
    </clipPath>
    <clipPath id="clippath-47">
      <rect class="cls-2" x="4886" y="8629.7" width="478.8" height="274.9"/>
    </clipPath>
    <linearGradient id="linear-gradient-15" x1="821.5" y1="415.3" x2="862.3" y2="415.3" gradientTransform="translate(-4662.7 13595) scale(11.6 -11.6)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-48">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-49">
      <path class="cls-2" d="M4956,8410.8c-.5,3.2-.7,6.5-.7,9.8,0,3.3.2,6.6.7,9.8,7.4,95.1,82.6,166.5,175.7,166.5s176.3-80.8,176.3-176.3-80.7-176.3-176.3-176.3-168.3,71.4-175.7,166.5M5131.2,8369.2h.2c28,.1,51.7,23.7,51.7,51.5s-22.1,50.3-49.4,51.4c-16.8.8-29-6.7-35.9-13.2-10.4-9.6-16.8-23.5-17.7-38.2,1.5-25.6,20.7-51.5,51-51.5"/>
    </clipPath>
    <clipPath id="clippath-50">
      <rect class="cls-2" x="4955.3" y="8244.3" width="352.7" height="352.7"/>
    </clipPath>
    <linearGradient id="linear-gradient-16" x1="956.9" y1="231.6" x2="997.7" y2="231.6" gradientTransform="translate(-3320.3 10423.4) scale(8.6 -8.6)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-51">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-52">
      <path class="cls-2" d="M6336,8707.7h0c-30.1-44.7-79-53.5-114.6-59.9-6.4-1.1-12.8-2.3-19.1-3.6-61.4-13.3-111.1-14.5-161.3-3.9-7.4,1.6-15.3,2.9-23.3,4.3-35.3,6.1-79.3,13.6-111.5,43-24.6,22.4-26.1,59.3-3.6,84.1,23.3,25.6,61.4,27.6,86.6,4.6,7.3-5.8,36.7-10.4,50.9-12.6,9.3-1.4,17.9-2.8,25.1-4.4,33-7.1,65.3-6.4,104.8,2.2,6.5,1.4,13.9,2.6,21.9,3.9,12.4,2,38.3,6.1,43.6,10.8,5.3,8,4.3,31.8,3.6,47.6-.3,7.2-.6,14.2-.6,20.7,0,33.7,26.7,60.2,60.8,60.2s29.2-5.2,40.3-14.7c13.2-11.4,20.5-27.5,20.5-45.5s.2-11.8.3-17.8c.8-35.7,1.8-80.1-24.3-118.9"/>
    </clipPath>
    <clipPath id="clippath-53">
      <rect class="cls-2" x="5880.1" y="8629.6" width="482.2" height="274.9"/>
    </clipPath>
    <linearGradient id="linear-gradient-17" x1="905.5" y1="415.2" x2="946.2" y2="415.2" gradientTransform="translate(-4637 13592.2) scale(11.6 -11.6)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-54">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-55">
      <path class="cls-2" d="M6116.6,8244.3c-95.6,0-176.3,80.8-176.3,176.3s80.8,176.3,176.3,176.3,168.3-71.5,175.7-166.6c.4-3.2.7-6.5.7-9.7,0-3.3-.2-6.5-.7-9.7-7.4-95.1-82.6-166.6-175.7-166.6M6114.4,8369.2c17-.8,29,6.8,36,13.2,10.4,9.7,16.8,23.5,17.6,38.2-1.5,25.7-20.7,51.6-51,51.6h-.2c-28-.1-51.7-23.7-51.7-51.5s22.1-50.3,49.3-51.4"/>
    </clipPath>
    <clipPath id="clippath-56">
      <rect class="cls-2" x="5940.2" y="8244.3" width="352.7" height="352.7"/>
    </clipPath>
    <linearGradient id="linear-gradient-18" x1="1068" y1="231.6" x2="1108.8" y2="231.6" gradientTransform="translate(-3296.1 10423.4) scale(8.6 -8.6)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-57">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-58">
      <path class="cls-2" d="M5719.1,8710c-6.7-1.2-13.4-2.4-19.8-3.8-59.1-12.8-110-13.7-160.6-3-7.1,1.5-15,2.8-23.2,4.1-34.1,5.5-76.6,12.4-106.4,39.4-46.5,42.1-45.4,101-44.7,144,0,5.5.2,11,.2,16.3,0,33.8,26.7,60.2,60.8,60.2s29.2-5.2,40.3-14.7c13.2-11.4,20.5-27.5,20.5-45.5s-.2-11.7-.3-17.9c-1.3-48,3.1-51.3,10.2-52.7,11.9-2.3,23.8-5,35.8-7.7,28.2-6.4,54.9-12.6,80.1-12.6s44.1,5.2,67.8,10.6c15.1,3.5,30.8,7.1,47.2,9.6,7.2,1.1,12.3,1.9,11,53.2-.1,6-.3,11.9-.3,17.5,0,33.8,26.7,60.2,60.8,60.2s29.2-5.2,40.3-14.7c13.3-11.4,20.6-27.5,20.6-45.5s.1-11.7.2-17.7c.8-35.7,1.8-80.2-24.3-119-30.3-44.9-79.9-53.8-116.2-60.2"/>
    </clipPath>
    <clipPath id="clippath-59">
      <rect class="cls-2" x="5362.7" y="8692.5" width="498.7" height="274.6"/>
    </clipPath>
    <linearGradient id="linear-gradient-19" x1="843.6" y1="438.4" x2="884.4" y2="438.4" gradientTransform="translate(-4889 14158) scale(12.2 -12.2)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-60">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-61">
      <path class="cls-2" d="M5435.2,8479c-.4,3.3-.7,6.5-.7,9.8s.2,6.5.7,9.8c7.5,95.1,82.6,166.6,175.7,166.6s176.3-80.8,176.3-176.3-80.8-176.3-176.3-176.3-168.3,71.5-175.7,166.6M5613,8540.2c-17,.8-29-6.8-35.9-13.2-10.4-9.7-16.8-23.5-17.7-38.3,1.5-25.6,20.7-51.5,51-51.5s.3,0,.3,0c28.1.1,51.7,23.7,51.7,51.5s-22.1,50.3-49.4,51.4"/>
    </clipPath>
    <clipPath id="clippath-62">
      <rect class="cls-2" x="5434.5" y="8312.4" width="352.7" height="352.7"/>
    </clipPath>
    <linearGradient id="linear-gradient-20" x1="1011" y1="223.9" x2="1051.8" y2="223.9" gradientTransform="translate(-3308.7 10425.4) scale(8.6 -8.6)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-63">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-64">
      <path class="cls-2" d="M780.1,5755.2v-537.1c0-25.3-20.2-45.2-45.8-45.2s-22.1,3.9-30.3,11.1c-9.9,8.5-15.4,20.6-15.4,34.1v265.5c0,31.8.4,63.7.8,95.6.8,62.2,1.6,126.6-.8,189.2-.8,20.6-13.7,33.9-34,34.7-3.6.1-7.3,0-10.9,0H134.5c-25,0-50,.2-75.1.6-48.8.7-99.2,1.4-148.1-.7-20.2-.9-33.2-14.2-33.9-34.9-.2-4.9-.1-9.8,0-14.8v-670.2c0-7.1-.2-14.4-.5-21.9-.6-15.4-1.3-31.4,1.3-43.8,4.4-21.1,16.7-25.7,67.3-25.7H470c25.4,0,45.2-20.1,45.2-45.8s-3.9-22.1-11.1-30.4c-8.5-9.9-20.6-15.3-34.2-15.3H190c-31,0-61.9-.4-92.9-.7-61.6-.7-125.4-1.4-188.1.7-72.4,2.4-123,58-123,135.3v668.4c0,7.3-.2,14.8-.3,22.2-.3,17-.7,34.5.6,52.2,4,56.8,47.3,104.8,103,114.2,11.3,1.9,21.9,2,31.3,1.8h676.6c6.5,0,13.1.2,19.8.4,7.5.2,15,.4,22.6.4,12.2,0,24.7-.6,37.2-2.7,55.8-9.3,99.1-57.4,103-114.3.6-8.1.5-15.9.4-23.3"/>
    </clipPath>
    <clipPath id="clippath-65">
      <rect class="cls-2" x="-215.1" y="4898.4" width="995.4" height="997.1"/>
    </clipPath>
    <linearGradient id="linear-gradient-21" x1="423.2" y1="888.8" x2="464" y2="888.8" gradientTransform="translate(-10538.5 27079.9) scale(24.4 -24.4)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-66">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-67">
      <path class="cls-2" d="M545.8,5508.3H20.1c-25.4,0-45.2,20.1-45.2,45.8s19.9,45.8,45.2,45.8h525.7c25.4,0,45.2-20.1,45.2-45.8s-19.9-45.7-45.2-45.7"/>
    </clipPath>
    <clipPath id="clippath-68">
      <rect class="cls-2" x="-25.1" y="5508.3" width="616.1" height="91.5"/>
    </clipPath>
    <linearGradient id="linear-gradient-22" x1="418.8" y1="771.9" x2="459.5" y2="771.9" gradientTransform="translate(-6351.3 17216) scale(15.1 -15.1)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-69">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-70">
      <path class="cls-2" d="M-25.1,5335.7c0,25.7,19.9,45.8,45.2,45.8h525.7c25.4,0,45.2-20.1,45.2-45.8s-19.9-45.8-45.2-45.8H20.1c-25.4,0-45.2,20.1-45.2,45.8"/>
    </clipPath>
    <clipPath id="clippath-71">
      <rect class="cls-2" x="-25.1" y="5289.9" width="616.1" height="91.5"/>
    </clipPath>
    <linearGradient id="linear-gradient-23" x1="418.8" y1="786" x2="459.5" y2="786" gradientTransform="translate(-6351.3 17210.6) scale(15.1 -15.1)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-72">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-73">
      <path class="cls-2" d="M3719.7,8987.8h-1240.5c-13.2,0-25.6-6.2-33.6-16.6-8-10.4-10.8-24-7.3-36.7l107.6-403.2c4.9-18.5,21.7-31.4,40.9-31.4h1025.3c19.2,0,36,12.9,40.9,31.4l107.6,403.2c3.4,12.7.7,26.3-7.4,36.7-8,10.4-20.4,16.6-33.6,16.6M2534.4,8903.1h1130.1l-84.9-318.4h-960.2l-85,318.4ZM3581.9,8857.5h-968c-23.5,0-42.4-19-42.4-42.4s19-42.4,42.4-42.4h968c23.4,0,42.4,19,42.4,42.4s-19,42.4-42.4,42.4M3555.7,8727.1h-915.7c-23.4,0-42.4-19-42.4-42.4s19-42.4,42.4-42.4h915.7c23.5,0,42.4,19,42.4,42.4s-19,42.4-42.4,42.4M3306.3,8492.7h-413.5c-23.5,0-42.4-19-42.4-42.4s19-42.4,42.4-42.4h95.4v-53.1h-508.9c-23.4,0-42.4-19-42.4-42.4v-872.9c0-23.4,19-42.4,42.4-42.4h1240.5c23.4,0,42.4,19,42.4,42.4v872.9c0,23.4-19,42.4-42.4,42.4h-508.9v53.1h95.4c23.4,0,42.4,19,42.4,42.4s-19,42.4-42.4,42.4M3073,8408h53.1v-53.1h-53.1v53.1ZM2521.6,8270.1h1155.7v-788.1h-1155.7v788.1Z"/>
    </clipPath>
    <clipPath id="clippath-74">
      <rect class="cls-2" x="2434.9" y="7397.2" width="1329.2" height="1590.7"/>
    </clipPath>
    <linearGradient id="linear-gradient-24" x1="509.6" y1="848.2" x2="550.3" y2="848.2" gradientTransform="translate(-14121.4 35755.1) scale(32.5 -32.5)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-75">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-76">
      <path class="cls-2" d="M5758.9,2686.3c-5.5-16.1-10.9-32.1-16.2-48.2h0c-1.5-4.4-2.8-8.9-4.1-13.5,11.7-10,23.3-19.9,35-29.9,39-33.4,79.3-67.8,118.3-102.4,16.6-14.6,31.2-31.8,42.3-49.7,28.6-45.9,24.7-97.7-10.5-138.5-14.8-17.2-33-33.2-52.4-46.5-77.8-53-157.5-105.9-234.5-157l-12.7-8.4c-52.7-35-108.6-35.7-153.4-1.9-22.3,16.8-35.5,38.3-39.4,63.9-4.8,31.9-10.4,64.4-15.8,95.8l-4.9,28.5c-.3,1.6-.6,3.2-1,4.9l-25.6,6.5c-31.1,7.8-62.3,15.7-93.4,23.9-13.1,3.4-28,7.3-41.2,14.8-27.3,15.5-43.6,40.8-44.8,69.4-1.2,28.4,13.5,55.9,39.4,73.5,21.9,14.9,45,21.6,68.7,19.7l17.1-1.4c59.9-4.8,121.7-9.7,182.5-16.5,45.8-5.1,85.4-42.6,96.4-91.1.6-2.7,1.2-5.3,1.8-8l38.5,30.8c-1.1,1.5-2.3,3-3.5,4.4-21.1,24.8-42.3,49.4-63.5,74.1l-20.4,23.7c-37.9,44.1-47.5,93.9-28.4,147.9,20,56.5,41.8,116.4,66.6,183,15.9,42.7,52.1,68.6,96.7,69.3h1.8c32.8,0,61.7-13.5,79.5-37.4,17.9-23.9,22.6-55.5,12.9-86.9-10-32.5-21.1-65.2-31.8-96.7M5757.5,2394.7c-1.5-16.1-13.2-27.4-21.9-34.5-17.9-14.6-35.9-28.9-54-43.2-22.8-18.1-46.3-36.7-69-55.6-9.1-7.5-20.2-11.5-31.3-11.5s-11.6,1.1-17.1,3.3c-15.9,6.4-26.6,20.8-28.5,38.4-1.8,16.3-5.6,32.5-9.6,49.6-1.2,5.1-2.4,10.3-3.6,15.4-4.8,21.5-12.5,28.3-34.4,30.3-14.5,1.3-29.1,2.8-43.6,4.2-16,1.6-32,3.2-48,4.6-30.6,2.8-57.9,5-83.4,6.8-4,.3-7.3.2-10.2-.4,1.6-.4,3.5-.9,5.6-1.4l1.8-.4c15.3-3.8,30.5-7.6,45.6-11.5,29.2-7.4,59.4-15.1,89.1-21.8,30.2-6.7,46-23.7,49.9-53.5,5.4-41.2,13-83,20.3-123.5l1.9-10.6c1.4-7.6,4.7-17.6,12.6-22.2,7.8-4.5,18-2.5,25.2,0,9.5,3.4,19.2,9.5,28.2,15.5,9.3,6.2,18.5,12.7,27.7,19.2,9.4,6.7,18.8,13.4,28.5,19.8,21.8,14.4,43.7,28.8,65.6,43.1,38.3,25,78,51,116.6,77,11.4,7.7,23,18.5,36.5,34.1,3,3.5,12.3,14.2.3,31.2-8.6,12.1-19.1,23.7-30.4,33.6-34.7,30.2-69.6,60.1-104.6,89.9-18.4,15.7-36.7,31.4-55.1,47.1-27.9,24.1-31.1,35-19.8,69.1,8.9,26.9,17.9,53.8,26.9,80.6l26.8,80.5c1.6,4.7,3.2,9.1,3.7,13,.6,3.9,0,5.6-.2,5.8-.3.4-2,1.4-6.3,1.8-4.3.4-11.6,1.1-17.9-15.8-8.5-23-16.9-46.1-25.3-69.2-12.3-33.8-24.6-67.5-37.3-101.1-10.5-27.8-6.5-49.1,13.3-71.2,31.4-34.8,62-71.2,91.7-106.3l16.8-19.8c8.6-10.2,18.3-23.9,16.8-40.3"/>
    </clipPath>
    <clipPath id="clippath-77">
      <rect class="cls-2" x="5203.4" y="2056.6" width="759.3" height="850.7"/>
    </clipPath>
    <linearGradient id="linear-gradient-25" x1="702.3" y1="986.6" x2="743" y2="986.6" gradientTransform="translate(-7685.9 20592.1) scale(18.4 -18.4)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-78">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-79">
      <path class="cls-2" d="M6055.5,2513.2h-.2c-62,0-120.1,24-163.6,67.7-43.3,43.4-67,101.2-66.7,162.7.6,127.7,101.4,227.6,228.9,227.6h.2c2.2,0,4.4,0,6.6,0,55.8,0,111.4-23.2,153.5-64.2,45.1-44,69.7-102.3,69.3-164.2-.9-126.5-103.2-229.5-228.1-229.6M6194.4,2740.1c.8,79-60,141.6-138.2,142.4h-1.6c-37.4,0-72.6-14.3-99.1-40.3-26.6-26.1-41.5-61.1-41.9-98.5-.7-75.7,62.4-140.6,137.8-141.8h2.3c37.2,0,72.2,14.2,98.7,40,26.7,26.1,41.7,61,42,98.2"/>
    </clipPath>
    <clipPath id="clippath-80">
      <rect class="cls-2" x="5824.7" y="2513.2" width="459.3" height="458"/>
    </clipPath>
    <linearGradient id="linear-gradient-26" x1="915.4" y1="916.1" x2="956.2" y2="916.1" gradientTransform="translate(-4467.9 13042) scale(11.2 -11.2)" xlink:href="#linear-gradient-8"/>
    <clipPath id="clippath-81">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-82">
      <path class="cls-2" d="M5279.1,2525.3h-.3c-128.2,0-229,99.9-229.6,227.2-1.4,59.7,21,116.4,63.1,159.9,43.4,44.9,102.9,71,163.2,71.6.7,0,1.5,0,2.2,0,59.5,0,118.5-24.5,162-67.3,43.4-42.7,67.5-100.1,67.8-161.6.4-60.9-23.2-118.4-66.5-162-43.3-43.6-100.8-67.7-161.9-67.8M5279.2,2894.7c-37.8.6-74-14.1-100.4-40.3-26.3-26.1-40.8-61.2-40.9-99.1,0-38.1,14.5-73.7,41.1-100.3,26.3-26.4,61.5-41,99-41h0c76.5,0,139.6,62.4,140.7,139,.5,37.4-13.6,72.7-39.8,99.4-26.5,27-61.9,42-99.7,42.2"/>
    </clipPath>
    <clipPath id="clippath-83">
      <rect class="cls-2" x="5047.8" y="2525.3" width="460" height="458.7"/>
    </clipPath>
    <linearGradient id="linear-gradient-27" x1="848.3" y1="914.9" x2="889.1" y2="914.9" gradientTransform="translate(-4484.4 13036.4) scale(11.2 -11.2)" xlink:href="#linear-gradient-8"/>
    <clipPath id="clippath-84">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-85">
      <path class="cls-2" d="M5318.4,2154.9h.8c39.4,0,76.8-15.5,105.1-43.7,28.7-28.5,44.5-66.2,44.6-106.2,0-40.1-15.3-77.7-43.3-105.7-28.2-28.3-66.1-43.8-106.7-43.8h0c-40.9,0-78.7,15.3-106.4,42.9-27.7,27.7-43,65.4-42.9,105.2-2.1,37,12.4,74.9,39.6,103.9,28.5,30.4,67.4,47.2,109.3,47.4M5258.1,2005.4c-.2-34.3,25.2-60.6,59.1-61.3h1.3c16.5,0,31.9,6.2,43.6,17.5,11.6,11.3,18.1,26.5,18.2,42.7.2,15.9-6.5,31.9-18.4,43.6-11.6,11.6-27.3,18.3-43,18.3h-.6c-33-.4-60-27.7-60.2-60.8"/>
    </clipPath>
    <clipPath id="clippath-86">
      <rect class="cls-2" x="5167.4" y="1855.5" width="301.6" height="299.4"/>
    </clipPath>
    <linearGradient id="linear-gradient-28" x1="1075" y1="936.3" x2="1115.8" y2="936.3" gradientTransform="translate(-2729.3 8884.1) scale(7.3 -7.3)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-87">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-88">
      <path class="cls-2" d="M1074.5,4586.9c-27-18.5-69.9-35.7-109.1-28-23.3,4.5-42.6,17.3-55.6,36.9-14.1,21.3-18.2,44.3-15.6,67.2l-86.1,86.1c-53.1-24.7-118.6-33.6-163.9,8.3-38.7,35.8-44.7,96.9-15.9,163.1,9,20.6,20.8,40.5,34.5,59.4-4.6,2.2-9,5-12.8,8.8l-108.9,109c-11.6,11.6-16.1,27.7-11.9,43.2,4.3,16,17.4,29.1,33.4,33.4,3.8,1,7.7,1.5,11.5,1.5,11.7,0,23-4.6,31.7-13.4l109-108.9c3.1-3.1,5.5-6.6,7.5-10.2,14.5,12.1,29.9,23,46.2,32.6,25.6,15,67,34.5,110,34.5s41.6-4.5,61.4-16.2c24.6-14.4,41.2-36.4,48.1-63.6,10.7-42.4-4-88.5-18-119.4l102.8-87.2c14.6,0,29.2-2.7,42.5-8.9,17-8,38.8-25.2,46-61.6,12.9-65.4-34.1-130.8-86.5-166.7M985.3,4648c6.2-.4,20.8,3.9,34.7,12.6,22.2,13.8,46.5,39.8,50.9,66.7.6,3.5.6,5.9.4,7.4-3.1.4-11.9-.2-31.3-10.8-4.9-2.7-10-4.3-15.1-5.1-2.1-5-5.2-9.7-9.2-13.8-21-21.9-33.8-45.8-30.5-57M883.4,4866.5c-9.8,8.4-14.5,19.1-14.2,29.9-1.8,10.2-.2,21.1,5.8,30.9h0c18.8,31.1,29.2,70.7,22.1,84.8-.7,1.4-2.5,5.1-14,6.2-33.9,3.3-79.6-20.5-122.1-63.9-42.3-43.3-64.3-88.1-58.8-120,1.7-9.7,5.2-11.3,7.1-12.1,13.4-5.9,42.7,1.6,67,13.5,6.3,8.5,15.4,15,25.7,17.8,3.8,1,7.7,1.5,11.5,1.5,11.7,0,23-4.7,31.8-13.5l90-90c4.9,6,9.9,11.8,15.1,17.3,7.1,7.4,15.9,11.8,25.2,13.3.7,1.5,1.5,2.9,2.3,4.4l-94.3,80Z"/>
    </clipPath>
    <clipPath id="clippath-89">
      <rect class="cls-2" x="524.9" y="4551.2" width="649" height="624.7"/>
    </clipPath>
    <linearGradient id="linear-gradient-29" x1="454.3" y1="824.1" x2="495.1" y2="824.1" gradientTransform="translate(-6552.9 17706.6) scale(15.6 -15.6)" xlink:href="#linear-gradient-2"/>
    <clipPath id="clippath-90">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-91">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-92">
      <path class="cls-2" d="M721.5,2530.1c-142.1,142-373.3,142-515.5,0-129.9-129.9-129.9-341.3,0-471.2,118.7-118.6,311.8-118.6,430.5,0,108.3,108.3,108.3,284.5,0,392.8-47.8,47.8-111.4,74.1-179.1,74.1s-131.2-26.3-179-74.1c-89.9-89.9-89.9-236.2,0-326.1,15.3-15.4,15.3-40.4,0-55.8-15.4-15.3-40.4-15.3-55.8,0-120.6,120.7-120.6,317,0,437.7,62.7,62.7,146.1,97.3,234.8,97.3s172.1-34.5,234.9-97.3c139.1-139.1,139.1-365.3,0-504.4-72.3-72.3-168.5-112.1-271-112.1h0c-102.5,0-198.7,39.8-271,112.1-77.7,77.7-120.5,181.2-120.5,291.4s42.8,213.7,120.5,291.4c83.6,83.6,194.9,129.7,313.5,129.7s229.9-46,313.5-129.7c7.5-7.5,11.6-17.4,11.6-27.9s-4.1-20.4-11.6-27.9c-14.9-14.9-40.9-14.9-55.8,0"/>
    </clipPath>
    <clipPath id="clippath-93">
      <rect class="cls-2" x="29.8" y="1891.1" width="801.6" height="824.5"/>
    </clipPath>
    <linearGradient id="linear-gradient-30" x1="427.8" y1="997.7" x2="468.6" y2="997.7" gradientTransform="translate(-8014.5 21063.3) scale(18.8 -18.8)" xlink:href="#linear-gradient-2"/>
    <clipPath id="clippath-94">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-95">
      <path class="cls-2" d="M381.3,8648.4c-1.6-11.9-8.2-22.6-18.1-29.4-8-5.5-17.7-7.8-27.2-7.1-20.4-69-69.9-184.7-182.6-242.1l-140.3-70.9c-.4-.2-.7-.3-1.1-.5-47.8-22.4-84.7-3.1-98.9,24.3-.9,1.9-1.8,3.8-2.6,5.8l-14.1-14.8c-8.2-25.5-36.5-113.1-46.5-139.8-11.8-31.8-42.6-51.1-76.8-48.5-28,1.5-49.7,16.4-55.4,37.9-1.8,6.9-1.9,14.1-.2,20.9l57.2,233.8c1,3.9,2.5,7.7,4.5,11.1,9.4,16.3,58,99.3,93.3,138.2,11.2,12.3,37.3,28.9,170.1,99.8,10.9,5.8,20.8,11.1,29.7,15.9-7.1,7.6-11.5,17.8-11.5,28.8v49.3c0,23.4,19,42.4,42.4,42.4h250.4c12.2,0,23.9-5.3,31.9-14.5,8.1-9.2,11.7-21.4,10.2-33.5l-14.3-107ZM143.3,8625.1c-14.1-7.9-34-18.6-60.7-32.8-36.2-19.3-131.3-70.1-148.5-83.5-22-24.8-55.9-78.8-75.3-111.7l24.9,26.2c5,5.3,10.9,9.5,17.1,12.4l33.7,16.1c1,.6,2,1.1,3,1.7.7.4,1.4.7,2.1,1.1l95.1,45c29.1,13.6,64,1.1,77.8-27.9,3.8-8,5.6-16.3,5.6-24.5,66.4,35.3,104.1,101,124.6,153.8l-99.4,24.3ZM253.5,8718.6l50-12.2,1.6,12.2h-51.6Z"/>
    </clipPath>
    <clipPath id="clippath-96">
      <rect class="cls-2" x="-283.7" y="1.4" width="6727.4" height="8986.4"/>
    </clipPath>
    <clipPath id="clippath-97">
      <rect class="cls-2" x="-283.7" y="8124.5" width="680.3" height="680.3"/>
    </clipPath>
    <linearGradient id="linear-gradient-31" x1="406.6" y1="628.7" x2="447.4" y2="628.7" gradientTransform="translate(-7058.7 18941.4) scale(16.7 -16.7)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#429fd6"/>
      <stop offset=".2" stop-color="#429fd6"/>
      <stop offset="1" stop-color="#48277c"/>
      <stop offset="1" stop-color="#1d1d1b"/>
    </linearGradient>
    <clipPath id="clippath-98">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-99">
      <path class="cls-2" d="M1098.4,8163.2c-5.7-21.6-27.4-36.4-55.4-37.9-34.1-2.6-65,16.8-76.8,48.5-10,26.8-38.3,114.4-46.5,139.8l-14.1,14.8c-.8-2-1.6-3.9-2.6-5.8-14.1-27.4-51.1-46.7-98.9-24.3-.4.2-.7.4-1.1.5l-140.3,70.9c-112.6,57.5-162.2,173.2-182.6,242.1-9.6-.7-19.2,1.6-27.2,7.1-10,6.8-16.5,17.5-18.1,29.4l-14.3,107c-1.6,12.1,2.1,24.3,10.1,33.5,8,9.2,19.7,14.5,31.9,14.5h250.4c23.4,0,42.4-19,42.4-42.4v-49.3c0-11.1-4.4-21.2-11.5-28.8,8.9-4.8,18.8-10.1,29.7-15.9,132.8-71,158.9-87.6,170.1-99.8,35.3-38.8,83.9-121.9,93.4-138.2,2-3.5,3.5-7.2,4.4-11.1l57.2-233.8c1.7-6.9,1.6-14.1-.2-20.9M511,8718.6l1.6-12.2,50,12.2h-51.6ZM882.1,8508.8c-17.2,13.3-112.4,64.2-148.5,83.5-26.7,14.3-46.6,25-60.7,32.8l-99.4-24.3c20.6-52.8,58.2-118.5,124.6-153.8,0,8.2,1.9,16.6,5.6,24.5,13.8,29,48.7,41.5,77.8,27.9l95.2-45c.7-.3,1.4-.7,2.1-1.1,1-.5,2-1.1,3-1.7l33.7-16.1c6.2-2.9,12.1-7.1,17.1-12.4l24.9-26.2c-19.5,32.9-53.3,86.9-75.3,111.7"/>
    </clipPath>
    <clipPath id="clippath-100">
      <rect class="cls-2" x="418.9" y="8122.7" width="681.3" height="680.8"/>
    </clipPath>
    <linearGradient id="linear-gradient-32" x1="447.8" y1="628.8" x2="488.6" y2="628.8" gradientTransform="translate(-7041.5 18941.4) scale(16.7 -16.7)" xlink:href="#linear-gradient-31"/>
    <clipPath id="clippath-101">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-102">
      <path class="cls-2" d="M6344,7844.3c-.4-10.4-.7-20.3-.7-29.5v-201.1c.3-15.1.5-32.2-2.7-49.6-10.9-59.8-53.7-106-106.7-115-19.5-3.3-38.7-2.7-55.5-2.2-5.8.2-11.6.4-17.3.4h-1061.4c-9.2,0-19.3-.5-30-1.1-66.9-3.3-191.6-9.4-211.2,123.3-5.1,34.4-3.9,69.6-2.8,103.6.4,13.3.9,26.4.9,39.2v182.7c0,93.5,51.5,158.4,128.2,161.4,32.8,1.3,65.7.9,97.6.4,13.4-.2,26.8-.4,40.2-.4l20.6,105.6c4.8,24.5,23.1,43.8,46.8,49.2,4.4,1,8.8,1.5,13.2,1.5,18,0,35-8.4,46.3-23.5l99.1-132.8h158.9l37.5,67.3c2,4.1,4.5,8,7.4,11.6,11.6,15.3,28.5,23.9,46.9,23.9,19.3.5,36.2-8.1,48.1-23.7,3-3.8,5.5-7.8,7.6-12l37.5-67.2h158.9l99.1,132.8c14,18.8,36.8,27.2,59.5,22.1,23.7-5.4,42-24.7,46.8-49.2l20.6-105.7h81.4c4.5,0,9,0,13.5.1,47.6.6,119.8,1.7,156.5-79,18.4-40.5,16.7-89.8,15.2-133.2M6221.7,7907.5c-1,19.2-8.4,19.3-14.9,19.5-30.9.6-62.6.4-93.2.2-15.8-.1-31.7-.2-47.5-.2h-38.3c-28.7,0-53.6,21.3-59.4,50.7l-4.1,21.2c-1.1-1.7-2.3-3.5-3.5-5.3-17.8-27.5-42.1-65.1-84.8-66.6-28.3-1-56.6-.7-84-.3-13.5.2-27,.3-40.5.3h-66.2c-1.8,0-3.7-.2-5.8-.4-10.6-.9-26.7-2.2-42.6,4.3-17,6.9-28.5,20.6-37.4,35.3-2.5-3.7-5.1-7.4-7.8-10.9-21.6-28.7-48-28.3-62.1-28.3h-198.9c-11.9-.2-33.9-.7-54.3,18.6-10.9,10.4-19.3,22.8-26.6,33.9-2.8,4-5.4,8.1-8.1,11.7l-6.3,8.4-4.2-21.9c-5.8-29.4-30.7-50.7-59.3-50.7h-118.8c-6.5,0-13.5.3-20.9.6-52.9,2.4-53.2-2-54.2-20.3-1.4-25.1-.9-50.7-.4-77.8.2-13.7.5-27.4.5-41v-173.7c0-25,4.6-37.8,13.6-38,17.7-.4,35.5-.2,53.2,0,9.2,0,18.4.1,27.5.1h1106.9c3.8,0,7.7,0,11.6-.2,24.6-.7,25.6,1,27.7,4.6,3.2,5.4,3.1,16.8,3.1,28.9v264.4c0,4.1,0,8.2.1,12.4.1,6.9.2,13.9,0,20.7"/>
    </clipPath>
    <clipPath id="clippath-103">
      <rect class="cls-2" x="4853.4" y="7436.9" width="1493.8" height="779.7"/>
    </clipPath>
    <linearGradient id="linear-gradient-33" x1="567.5" y1="881.7" x2="608.3" y2="881.7" gradientTransform="translate(-15882.7 40041.5) scale(36.5 -36.5)" xlink:href="#linear-gradient-2"/>
    <clipPath id="clippath-104">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-105">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-106">
      <path class="cls-2" d="M3315.3,7637.4c-16.5-35.6-46.2-68.1-96.8-85.8-118.7-41.3-227.9,35.3-261.9,62.9-30.3,7-98.2,29-126.8,90-13.1,27.9-15.8,58.5-8.2,91.7-32.1,27-56.2,73.3-37.7,137.7,11.3,39.3,34.4,68.9,67,85.6,55.3,28.4,118.1,9.7,136,3.3,38-13.6,60-50.7,72.1-81,53.8-3.6,85.2-44,95.2-68.7l-43.1-17.5-42.5-18.6c-7,14.7-20.1,12.2-25,11.2-1-.2-2.1-.4-3.2-.7-1.3-.4-2.7-.8-4.1-1.1-6.9-2.3-13.7-7.2-12.4-20l-.2,1.1-91.8-14.8c-.3,2.2-.6,4.4-.8,6.7-3.2-5.4-6.4-11.2-9.3-17.3-1-2.9-2.2-5.6-3.6-8.2-7.2-17.4-10.9-35.6-4.5-49.6,11.9-25.8,56.1-38.1,70.4-40.4,9.2-1.4,17.9-5.5,24.7-11.8.9-.8,91.9-82.8,179.1-52.5,35,12.2,47.2,39.7,50.8,63.3-19.7-30.6-74.4-76.3-150.6-43.5-67.3,29-73.5,94-61.3,130.6l44.1-14.8,44.5-13.5c-3-11.4,3.6-14.2,9.5-16.8,15.5-6.7,27.7-3.6,36.2,9.1,13.5,21.5,41.6,28.2,63.4,15,5.4-3.3,9.9-7.5,13.4-12.3,2.4,19.3,16.9,35.8,36.9,39.8,25.2,5.1,49.6-11.3,54.7-36.5,1-5,1.8-10.5,2.4-16.3,26.3,17.6,46.2,46.1,46.2,68.5s-24.7,57.7-58,65.3c-15.1-52.4-54.3-79-117-79s-46.5,20.8-46.5,46.6,20.8,46.6,46.5,46.6,31.2,2.4,31.2,42.6-1.2,8.6-4.1,10.6c-6.2,4.2-26.8,14.1-85.4,14.1s-86.9,25.1-102.9,46.2c-44.3,58.1-22.2,145.5-19.5,155.3,5.6,20.7,24.3,34.2,44.7,34.2s8.1-.5,12.1-1.6c24.7-6.6,39.4-32.2,32.9-56.9-5.5-20.9-8.1-59.1,3.8-74.6,1.8-2.3,7.3-9.4,29-9.4,100,0,159.2-27.1,176.8-80.5,84.1-9.9,149.4-77.6,149.4-159.4s-73.2-158.4-155.9-174.9M2916.7,7885c9.1-5.5,15.6-13.6,19.1-22.8,5.6,18.7,16.4,37.2,34,51.8-4.9,10.6-10.2,19-14.1,21-19.2,6.9-45.9,10-62.4,1.5-6-3.1-14.6-9.4-20.1-28.5-2.4-8.2-3.1-15.5-2.4-21.7,13.9,7.3,31.3,7.4,45.8-1.4"/>
    </clipPath>
    <clipPath id="clippath-107">
      <rect class="cls-2" x="2765.5" y="7510.3" width="705.7" height="684.4"/>
    </clipPath>
    <linearGradient id="linear-gradient-34" x1="583" y1="672.6" x2="623.8" y2="672.6" gradientTransform="translate(-7138.6 19292.4) scale(17 -17)" xlink:href="#linear-gradient-2"/>
    <clipPath id="clippath-108">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-109">
      <path class="cls-2" d="M3055.4,5393.2l22.5,22.5v106.7l-57.8.6-.9-179.7h10.8c2.5,15.9,9.4,30.8,19.9,43.4-13.1-20-31.8-77.2-46-124.6h-6.8c-6.9,0-13.6,1.3-20.4,4.1-88.2-24.9-156.7-93.5-181.6-181.6,2.7-6.7,4.1-13.4,4.1-20.4v-102.9c0-7-1.3-13.7-4.1-20.4,24.9-88.2,93.5-156.8,181.7-181.6,6.7,2.8,13.4,4.1,20.3,4.1h102.9c6.9,0,13.6-1.3,20.3-4.1,88.2,24.9,156.8,93.5,181.6,181.6-2.7,6.7-4.1,13.4-4.1,20.4l177,161.3h59.9l84.6-14.9c12.8-11,20.1-26.5,20.1-43.5v-102.9c0-16.6-7.5-32.4-20-43.4-40.5-246-230.1-435.6-476.1-476.1-10.9-12.7-26.5-20-43.4-20h-103c-16.6,0-32.4,7.5-43.4,20-246,40.5-435.7,230.1-476.1,476.1-12.6,11-20,26.7-20,43.4v102.9c0,15.5,6.3,30.5,17.1,41.3,1,1,2,1.9,3,2.7,40.7,245.7,230.2,435,476,475.5,11,12.7,26.5,20.1,43.4,20.1h102.9c16.9,0,32.5-7.3,43.4-20.1,27.1-4.5,54.6-11.3,82.2-20.2,0,0-148.5-155.7-170.2-170.3M3558.9,5041.1l-166.7.8-13.2-12.8-.4-45.8h179.7c0,0,.6,57.8.6,57.8ZM3158.4,4526.2c187.7,42,334.6,188.9,376.6,376.6h-160.2c-34.2-101.4-115-182.2-216.5-216.4v-160.2ZM3019.1,4502.9l57.9-.6.8,179.7-58.7.6v-179.7ZM2938.7,4526.2v160.2c-101.3,34.2-182.2,115-216.5,216.5h-160.2c42-187.7,188.9-334.6,376.6-376.6M2538.2,4984.2l179.7-.8.6,58.7h-179.7l-.6-57.9ZM2938.7,5499.1c-187.6-42-334.5-188.9-376.6-376.6h160.2c34.3,101.4,115.1,182.2,216.5,216.4v160.2ZM3158.4,5499v-2.9l2.4,2.4c-.8.2-1.6.4-2.4.5"/>
    </clipPath>
    <clipPath id="clippath-110">
      <rect class="cls-2" x="2457.5" y="4421.7" width="1182" height="1182"/>
    </clipPath>
    <linearGradient id="linear-gradient-35" x1="517.4" y1="929.3" x2="558.2" y2="929.3" gradientTransform="translate(-12539.1 31945.1) scale(29 -29)" xlink:href="#linear-gradient-2"/>
    <clipPath id="clippath-111">
      <rect class="cls-2" x="-94.8" y="-84.4" width="1236.1" height="1459.2"/>
    </clipPath>
    <clipPath id="clippath-112">
      <path class="cls-2" d="M3799.9,5417.1c-14.7-14.7-37.8-16.2-54.1-4.2-2.3-16.7-2.8-36-3.3-56-1.7-66.9-3.7-150.1-70-216.4l-56.3-54.2c.7-3.7-20.6-15.1-19.9-18.8,0,0-16.2-22-42.5-13.2-11.6,3.9-20.5,5.3-23.5,23.5l.3,12.9c-.5,2.2-1,4.3-1.4,6.3h0c-3.6,14.2-7.6,28-11.9,41.2,0,0-149.4-136.4-206.9-185.1l-25.3-16.8c-4.8-.7-9.7-1.1-14.6-1.1-25.2,0-48.9,10-66.5,27.7-11.9,11.8-20.2,26.3-24.4,42.2-20.7,2.7-39.8,12-54.6,27-14.9,14.9-24.2,33.9-26.8,54.6-16,4.2-30.6,12.6-42.5,24.6-17.8,17.7-27.6,41.4-27.6,66.7,0,16,4,31.4,11.5,45-1.2,4.9-1.9,7.5-3.1,12.4l-14.2,8.4c-5.5,3.3-9,9.1-9.5,15.6-1.5,20.6-12.2,37.6-5.3,60.1,3,19.5,12,37.6,26.3,51.8l23.3,23.3,83.4,83.4h0s2.4,2.4,2.4,2.4l67.3,67.3,55.9,56,4.1,3.8c52.2,50.2,102.3,58.1,142.7,64.4,21.7,3.4,40.3,6.4,58.2,15l-3,3c-6.2,6.2-11.1,14-12.6,22.8-2.6,13.9,1.7,27.5,11.5,37.4l67.3,67.3c7.9,7.9,18.4,12.3,29.5,12.3h274c23,0,41.7-18.7,41.7-41.7v-273.9c0-11.1-4.3-21.5-12.2-29.4l-67.4-67.3ZM3531.8,5625.7c-37.5-25.5-73.6-31.2-105.8-36.3-37.1-5.8-66.4-10.4-100.7-44.7l-232.5-232.6c-2.1-2-3.2-4.7-3.2-7.6s1.1-5.7,3.2-7.7c2.1-2.1,4.9-3.2,7.7-3.2s5.4,1,7.4,3l82.7,82.6c15.7,15.7,43.2,15.7,59,0,16.2-16.2,16.2-42.7,0-58.9l-134.8-134.8c-2.1-2.1-3.2-4.7-3.2-7.6s1.1-5.6,3.2-7.7c4.2-4.2,11.3-4,15-.3l135.2,135.1c15.7,15.8,43.2,15.8,58.9,0,16.2-16.2,16.2-42.7,0-58.9l-132.7-132.6-7.5-7.5c-1.8-2-2.8-4.5-2.8-7.2s1.1-5.6,3.2-7.7c4.1-4.1,11.5-4,15.2-.2l1,1c1.2,1.6,2.5,3.1,4,4.6l133.5,133c16.4,16.2,42.8,16,58.9-.2,16.2-16.3,16.1-42.7-.2-58.9l-133.4-132.8c-2-2.1-3.1-4.7-3.2-7.6,0-3,1.1-5.7,3.2-7.7s6.1-3.2,7.7-3.2,4.9.4,7.9,3.4l225.9,220c2.1,2,4.2,3.4,5.2,4,1.2,1,2.9,2.2,5.1,3.3l3.2,1.5,1.3.2c2.2.7,4.1,1.2,5.4,1.4.7.2,1.9.5,3.5.7l5.3.5c2.6,0,4.7-.4,6.5-.8,2-.2,5-.7,8.2-2,2-.7,3.9-1.8,5.8-2.9,1.3-.7,3.1-1.8,5.1-3.3l2.1-1.2,2.6-2.9c1.5-1.6,2.7-3.3,3.4-4.5,1-1.2,2.2-2.9,3.2-4.9.1-.2,9.5-18.3,21.4-52.6l22.3,21.5c42.1,42.1,43.6,98.9,45.1,159.3,1.1,41.5,2.1,84.2,19.2,120.1l-146.7,146.2ZM3796.1,5746.1h-215l-25.7-25.7,215.1-215,25.6,25.7v215Z"/>
    </clipPath>
    <clipPath id="clippath-113">
      <rect class="cls-2" x="3000.6" y="4935.1" width="878.8" height="894.4"/>
    </clipPath>
    <linearGradient id="linear-gradient-36" x1="566" y1="865.5" x2="606.8" y2="865.5" gradientTransform="translate(-9127.2 23936.2) scale(21.4 -21.4)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-114">
      <path class="cls-2" d="M315.3,936.8c-136.3-193.1-208.3-342.5-208.3-432.2,0-217.5,177-394.5,394.5-394.5s394.5,177,394.5,394.5-72.1,239.2-208.4,432.2c-73.5,104.1-147.6,195-186.2,240.9-38.5-45.9-112.7-136.9-186.2-240.9M7.6,495.3c0,263.1,446.2,774.8,465.3,796.5l28.6,32.7,28.6-32.7c19-21.7,465.3-533.4,465.3-796.5S773.8,1.4,501.5,1.4,7.6,222.9,7.6,495.3"/>
    </clipPath>
    <linearGradient id="linear-gradient-37" x1="432" y1="1078.2" x2="472.7" y2="1078.2" gradientTransform="translate(-10453.9 26777.3) scale(24.2 -24.2)" xlink:href="#linear-gradient"/>
    <clipPath id="clippath-115">
      <path class="cls-2" d="M318,492.6c0-101.1,82.3-183.4,183.4-183.4s183.4,82.3,183.4,183.4-82.3,183.4-183.4,183.4-183.4-82.3-183.4-183.4M223.3,492.6c0,153.4,124.8,278.2,278.2,278.2s278.2-124.8,278.2-278.2-124.8-278.2-278.2-278.2-278.2,124.8-278.2,278.2"/>
    </clipPath>
    <linearGradient id="linear-gradient-38" x1="433.1" y1="1102.7" x2="473.9" y2="1102.7" gradientTransform="translate(-5685.1 15534.6) scale(13.6 -13.6)" xlink:href="#linear-gradient-2"/>
  </defs>
  <g class="cls-44">
    <path class="cls-34" d="M505.6,1308.6s422.7-547.4,422.7-788.6S739.1,83.4,505.6,83.4,82.9,278.9,82.9,520s360.9,772.3,422.7,788.6"/>
  </g>
  <g class="cls-45">
    <g class="cls-48">
      <g class="cls-47">
        <rect class="cls-4" x="-242" y="1746.2" width="1261.3" height="1472.5"/>
      </g>
    </g>
  </g>
  <g class="cls-46">
    <g class="cls-52">
      <g class="cls-51">
        <rect class="cls-37" x="-143.6" y="7537.7" width="1128.4" height="890.4"/>
      </g>
    </g>
  </g>
  <g class="cls-49">
    <path class="cls-35" d="M301.3,7719.6c-4.4-8.7-12.1-15-21.5-18-55.5-17.2-108.2-9.7-152.5,21.6-53.1,37.5-88.8,109.4-88.7,179,0,19.8,16.3,35.9,36.3,35.9s36.3-16.1,36.3-36c0-46.7,23.9-96.2,58.2-120.4,25.4-18,55.3-21.9,89-11.4,19,5.6,38.8-4.6,45-23.2,3-9.1,2.2-18.9-2.2-27.4"/>
  </g>
  <g class="cls-50">
    <g class="cls-53">
      <g class="cls-137">
        <rect class="cls-38" x="5012.5" y="4883.2" width="729.9" height="1064.3"/>
      </g>
    </g>
  </g>
  <g class="cls-142">
    <g class="cls-136">
      <g class="cls-135">
        <rect class="cls-36" x="5188.9" y="4467.3" width="422.8" height="424.7"/>
      </g>
    </g>
  </g>
  <g class="cls-134">
    <g class="cls-138">
      <g class="cls-140">
        <rect class="cls-42" x="4877.2" y="5251.4" width="491.9" height="748.5"/>
      </g>
    </g>
  </g>
  <g class="cls-139">
    <path class="cls-3" d="M6390.1,5240.2h-713.3c-30.1,0-53.7,23.9-53.7,54.3s4.7,26.2,13.1,36c10.1,11.8,24.5,18.3,40.6,18.3h317.9c-2.1,5.8-3.4,11.9-3.4,18.4v516.2h-69.2c-30.1,0-53.7,23.9-53.7,54.3s4.7,26.1,13.1,36c10.1,11.8,24.5,18.3,40.6,18.3h247c30.1,0,53.7-23.9,53.7-54.3s-4.6-26.2-13.1-36c-10.1-11.8-24.5-18.3-40.5-18.3h-69.2v-516.2c0-6.5-1.3-12.6-3.4-18.4h293.6c30.1,0,53.7-23.8,53.7-54.3s-23.6-54.3-53.7-54.3"/>
  </g>
  <g class="cls-143">
    <g class="cls-141">
      <g class="cls-56">
        <rect class="cls-43" x="5818.6" y="4774.8" width="416.4" height="458"/>
      </g>
    </g>
  </g>
  <g class="cls-57">
    <g class="cls-60">
      <g class="cls-59">
        <rect class="cls-41" x="2758.8" y="2183.8" width="336.7" height="94.5"/>
      </g>
    </g>
  </g>
  <g class="cls-58">
    <g class="cls-61">
      <g class="cls-85">
        <rect class="cls-39" x="2459.9" y="2124.5" width="248.8" height="207"/>
      </g>
    </g>
  </g>
  <g class="cls-83">
    <g class="cls-84">
      <g class="cls-86">
        <rect class="cls-40" x="2758.8" y="2450.9" width="336.7" height="94.5"/>
      </g>
    </g>
  </g>
  <g class="cls-94">
    <g class="cls-96">
      <g class="cls-93">
        <rect class="cls-20" x="2459.9" y="2391.6" width="248.7" height="207"/>
      </g>
    </g>
  </g>
  <g class="cls-92">
    <g class="cls-87">
      <g class="cls-88">
        <rect class="cls-17" x="2758.8" y="2718" width="336.7" height="94.5"/>
      </g>
    </g>
  </g>
  <g class="cls-89">
    <g class="cls-90">
      <g class="cls-95">
        <rect class="cls-18" x="2459.9" y="2658.7" width="248.7" height="207"/>
      </g>
    </g>
  </g>
  <g class="cls-91">
    <g class="cls-64">
      <g class="cls-66">
        <rect class="cls-19" x="2302.6" y="1816.9" width="1014.9" height="1299.7"/>
      </g>
    </g>
  </g>
  <g class="cls-65">
    <g class="cls-68">
      <g class="cls-62">
        <rect class="cls-28" x="3019.8" y="1996.1" width="1131.9" height="1029" transform="translate(-642.3 3643.7) rotate(-50)"/>
      </g>
    </g>
  </g>
  <g class="cls-63">
    <g class="cls-69">
      <g class="cls-67">
        <rect class="cls-24" x="4886" y="8629.7" width="478.8" height="274.9"/>
      </g>
    </g>
  </g>
  <g class="cls-70">
    <g class="cls-71">
      <g class="cls-108">
        <rect class="cls-22" x="4955.3" y="8244.3" width="352.7" height="352.7"/>
      </g>
    </g>
  </g>
  <g class="cls-109">
    <g class="cls-110">
      <g class="cls-106">
        <rect class="cls-21" x="5880.1" y="8629.6" width="482.2" height="274.9"/>
      </g>
    </g>
  </g>
  <g class="cls-107">
    <g class="cls-111">
      <g class="cls-112">
        <rect class="cls-27" x="5940.2" y="8244.3" width="352.7" height="352.7"/>
      </g>
    </g>
  </g>
  <g class="cls-113">
    <g class="cls-114">
      <g class="cls-122">
        <rect class="cls-23" x="5362.7" y="8692.5" width="498.7" height="274.6"/>
      </g>
    </g>
  </g>
  <g class="cls-54">
    <g class="cls-116">
      <g class="cls-118">
        <rect class="cls-30" x="5434.5" y="8312.4" width="352.7" height="352.7"/>
      </g>
    </g>
  </g>
  <g class="cls-124">
    <g class="cls-117">
      <g class="cls-123">
        <rect class="cls-26" x="-215.1" y="4898.4" width="995.4" height="997.1"/>
      </g>
    </g>
  </g>
  <g class="cls-125">
    <g class="cls-120">
      <g class="cls-119">
        <rect class="cls-29" x="-25.1" y="5508.3" width="616.1" height="91.5"/>
      </g>
    </g>
  </g>
  <g class="cls-55">
    <g class="cls-126">
      <g class="cls-130">
        <rect class="cls-25" x="-25.1" y="5289.9" width="616.1" height="91.5"/>
      </g>
    </g>
  </g>
  <g class="cls-128">
    <g class="cls-121">
      <g class="cls-132">
        <rect class="cls-32" x="2434.9" y="7397.2" width="1329.2" height="1590.7"/>
      </g>
    </g>
  </g>
  <g class="cls-127">
    <g class="cls-133">
      <g class="cls-131">
        <rect class="cls-16" x="5203.4" y="2056.6" width="759.3" height="850.7"/>
      </g>
    </g>
  </g>
  <g class="cls-129">
    <g class="cls-115">
      <g class="cls-78">
        <rect class="cls-33" x="5824.7" y="2513.2" width="459.3" height="458"/>
      </g>
    </g>
  </g>
  <g class="cls-75">
    <g class="cls-80">
      <g class="cls-76">
        <rect class="cls-31" x="5047.8" y="2525.3" width="460" height="458.7"/>
      </g>
    </g>
  </g>
  <g class="cls-72">
    <g class="cls-77">
      <g class="cls-74">
        <rect class="cls-15" x="5167.4" y="1855.5" width="301.6" height="299.4"/>
      </g>
    </g>
  </g>
  <g class="cls-79">
    <g class="cls-73">
      <g class="cls-82">
        <rect class="cls-7" x="524.9" y="4551.2" width="649" height="624.7"/>
      </g>
    </g>
  </g>
  <g class="cls-103">
    <path class="cls-1" d="M567.7,2144.5c-10.3-62.9-64.9-126.4-163.7-126.4h-27.1c-22.9,0-40.7,16.3-40.7,37.2s17.9,37.2,40.7,37.2h27.1c53.7,0,78.3,34.3,83.2,63.6,5.6,34.2-13.9,67.3-51,86.5-12.6,6.5-20.1,18.6-20.1,32.2v44c0,20.8,17.9,37.2,40.7,37.2s40.7-16.3,40.7-37.2v-23.6c62.8-41.9,77.8-104.4,70.2-150.6"/>
    <path class="cls-1" d="M419.3,2436.6c0,26.1,21.2,47.3,47.3,47.3s47.3-21.2,47.3-47.3-21.2-47.3-47.3-47.3-47.3,21.2-47.3,47.3"/>
  </g>
  <g class="cls-101">
    <g class="cls-104">
      <g class="cls-99">
        <rect class="cls-9" x="29.8" y="1891.1" width="801.6" height="824.5"/>
      </g>
    </g>
  </g>
  <g class="cls-100">
    <g class="cls-97">
      <g class="cls-102">
        <g class="cls-105">
          <rect class="cls-10" x="-283.7" y="8124.5" width="680.3" height="680.3"/>
        </g>
      </g>
    </g>
  </g>
  <g class="cls-81">
    <g class="cls-98">
      <g class="cls-151">
        <rect class="cls-8" x="418.9" y="8122.7" width="681.3" height="680.8"/>
      </g>
    </g>
  </g>
  <g class="cls-157">
    <g class="cls-152">
      <g class="cls-153">
        <rect class="cls-6" x="4853.4" y="7436.9" width="1493.8" height="779.7"/>
      </g>
    </g>
  </g>
  <g class="cls-156">
    <path class="cls-3" d="M5599.9,7653.1c-39.1,0-71.5,32.1-72.3,71.5-.8,39,30.8,71.8,70.4,73.1.8,0,1.5,0,2.3,0,33.4,0,61.7-22.7,69.8-56,1.5-5.4,2.2-10.9,2.2-16.3,0-5.1-.6-10.2-2-15.4-7.7-33.6-36.5-56.9-70.4-56.9"/>
    <path class="cls-3" d="M5424.9,7653.1c-39.1,0-71.5,32.1-72.3,71.5-.8,39,30.8,71.8,70.4,73.1.8,0,1.5,0,2.3,0,33.4,0,61.7-22.7,69.8-56,1.5-5.4,2.2-10.9,2.2-16.3,0-5.1-.6-10.2-2-15.4-7.7-33.6-36.4-56.9-70.4-56.9"/>
    <path class="cls-3" d="M5776.9,7653.2h0c-33.6-.8-63.9,22.4-72.1,56-1.5,5.4-2.2,10.9-2.2,16.3,0,5.1.6,10.2,2,15.3,7.7,33.6,36.5,57,70.4,57s71.6-32.1,72.3-71.5c.7-39-30.8-71.8-70.3-73.1"/>
  </g>
  <g class="cls-150">
    <g class="cls-159">
      <g class="cls-154">
        <rect class="cls-12" x="2765.5" y="7510.3" width="705.7" height="684.4"/>
      </g>
    </g>
  </g>
  <g class="cls-158">
    <g class="cls-155">
      <g class="cls-147">
        <rect class="cls-14" x="2457.5" y="4421.7" width="1182" height="1182"/>
      </g>
    </g>
  </g>
  <g class="cls-146">
    <g class="cls-145">
      <g class="cls-144">
        <rect class="cls-11" x="3000.6" y="4935.1" width="878.8" height="894.4"/>
      </g>
    </g>
  </g>
  <g class="cls-149">
    <rect class="cls-13" x="7.6" y="1.4" width="987.8" height="1323"/>
  </g>
  <g class="cls-148">
    <rect class="cls-5" x="223.3" y="214.4" width="556.4" height="556.4"/>
  </g>
</svg>`;

export class AsdSearchResultsMap extends React.Component {

    getMapOptions() {
        return {
            center: {
                lat: 0,
                lng: 0,
            },
            zoom: 14,
            streetViewControl: this.props.streetViewControl || false,
            mapTypeControl: this.props.mapTypeControl || false,
            fullscreenControl: this.props.fullscreenControl || false,
        };
    }

    filterLocations(locations) {

        if (!locations || (Array.isArray(locations) && locations.length === 0)) {
            return [];
        }

        if (!Array.isArray(locations)) {
            const { latitude, longitude } = locations;
            if (latitude && longitude) {
                return [{ ...locations }];
            } else {
                console.error("Invalid location object: missing latitude or longitude.");
                return [];
            }
        }

        return locations.filter(location => location.latitude && location.longitude);
    }

    componentDidMount() {
        this.loader = new Loader({
            apiKey: this.props.apiKey,
            version: "weekly",
            libraries: ["places"],
        });

        this.loader.loadCallback((e) => {
            if (e) {
                console.error(e);
            } else {
                this.drawMap();
            }
        });
    }

    drawMap() {
        if (this.loader && this.loader.done) {
            const mapElement = document.getElementById(this.props.id);

            this.map = new google.maps.Map(mapElement, this.getMapOptions());
            this.mapBounds = new google.maps.LatLngBounds();
            this.markers = [];
            this.infoWindow = null;
            this.searchLocation = this.props.searchLocation;

            const { locations } = this.props;
            this.addLocations(locations);

            const that = this;

            // Add click event listener to map to close marker info window if clicking elsewhere on the map
            google.maps.event.addListener(this.map, 'click', function () {
              if (that.infoWindow) {
                that.infoWindow.close();
              }
            });
        }
    }

    addLocations(locations) {

      if (!locations || !locations.length || !this.map || !this.mapBounds) {
        return;
      }

      const filteredLocations = this.filterLocations(locations);

      filteredLocations.forEach((location, i) => {

          const svgIconUrl = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(Marker)}`;
          
          const distanceText = (location.distanceFromSearchLocation || location.distanceFromSearchLocation === 0) && location.distanceUnit
          ? `${location.distanceFromSearchLocation} ${location.distanceFromSearchLocation === 1 ? location.distanceUnit.slice(0, -1) : location.distanceUnit} from ` + this.searchLocation
          : '';

          const infoWindowContent = location.categories && location.categories.length ?
          `
          <div class="map-info-window">
              <a href="${location.pageUrl}" target="_blank"><h3>${location.title}</h3></a>
              <p>${location.description}</p>
              <p class="accent"><span><img src="${svgIconUrl}" />${distanceText}</span></p>
              <div class="footer">
                  <div>
                      <p class="accent"><b>Service:</b><br /> ${location.categories.join(', ')}</p>
                  </div>
                  <div>
                      <a href="${location.pageUrl}" target="_blank"><svg aria-hidden="true" class="service-card__arrow"><use href="#icon-right"></use></svg></a>
                  </div>
              </div>
          </div>
          `
          :
          `
          <div class="map-info-window">
              <a href="${location.pageUrl}" target="_blank"><h3>${location.title}</h3></a>
              <p>${location.description}</p>
              <p class="accent"><span><img src="${svgIconUrl}" />${distanceText}</span></p>
              <div class="footer">
                  <div>
                  </div>
                  <div>
                      <a href="${location.pageUrl}" target="_blank"><svg aria-hidden="true" class="service-card__arrow"><use href="#icon-right"></use></svg></a>
                  </div>
              </div>
          </div>
        `;

        const latLng = new google.maps.LatLng({
          lat: parseFloat(location.latitude),
          lng: parseFloat(location.longitude),
        });

        const existingMarker = this.markers.find((x) => x.getPosition().equals(latLng));

        if (existingMarker) {
          existingMarker.InfoWindowContent += `<hr/>${infoWindowContent}`;
          existingMarker.title += '\n' + location.title;
        }
        else {

          this.mapBounds.extend(latLng);

          const marker = new google.maps.Marker({
              position: latLng,
              map: this.map,
              title: location.title,
              InfoWindowContent: infoWindowContent,
              NodeGuid: location.NodeGuid,
              icon: {
                  url: svgIconUrl,
                  scaledSize: new google.maps.Size(40, 40),
              }
          });

          const that = this;

          google.maps.event.addListener(marker, 'click', function () {

              //  Raise a map-marker-clicked event and expose the selected node guid
              var event = document.createEvent("HTMLEvents");
              event.initEvent("map-marker-clicked", true, true);
              event.eventName = "map-marker-clicked";
              event.NodeGuid = this.NodeGuid;
              document.dispatchEvent(event);

              that.openMarkerInfoWindow(this);
          });

          this.markers.push(marker);
        }
      });

      this.zoomToLocations();
    }

    zoomToLocations() {

      if (!this.mapBounds || !this.markers) {
        return;
      }

      if (this.markers.length === 1) {
        this.map.panTo(this.markers[0].position);
      }
      else {
        this.map.fitBounds(this.mapBounds);
      }
    }

    openLocation(latitude, longitude) {

      if (!this.markers || !latitude || !longitude) {
        return;
      }

      const latLng = new google.maps.LatLng({
        lat: parseFloat(latitude),
        lng: parseFloat(longitude),
      });

      const marker = this.markers.find((x) => x.getPosition().equals(latLng));

      this.openMarkerInfoWindow(marker);
    }

    openMarkerInfoWindow(marker) {

      if (!marker) {
        return;
      }

      //  Create an Info window where content has been provided
      if (marker.InfoWindowContent) {

        if (this.infoWindow) {
          this.infoWindow.close();

          this.infoWindow.setContent(marker.InfoWindowContent);
          this.infoWindow.setPosition(marker.position);
        }
        else {
          this.infoWindow = new google.maps.InfoWindow({
              content: marker.InfoWindowContent,
              position: marker.position
          });
        }

        this.infoWindow.open(this.map);
      }
    }

    removeAllLocations() {

      if (!this.markers || !this.markers.length) {
        return;
      }

      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }

      this.markers = [];
    }

    update(locations, searchLocation) {

      this.removeAllLocations();
      this.mapBounds = new google.maps.LatLngBounds();
      this.searchLocation = searchLocation;

      this.addLocations(locations);
    }

    render() {
        const style = {
            width: typeof this.props.width === 'string' ? this.props.width : `${this.props.width}px`,
            height: typeof this.props.height === 'string' ? this.props.height : `${this.props.height}px`,
        };

        return (
            <div style={{ paddingTop: '15px' }}>
                <div className="map" style={style} id={this.props.id}></div>
            </div>
        );
    }
}


